/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { Fragment } from "react";

import { useLocation } from "react-router";

import InlineToggleSwitch from "@/components/Table/components/InlineToggleSwitch/InlineToggleSwitch";
import TableCell from "@mui/material/TableCell";

import { colors } from "@dotnet/telematics-design-system";

import { useAuth } from "../../../../../context/Auth/AuthProvider";
import {
  ROUTES,
  tableColumnDropShadow,
  TableRowData
} from "../../../../../shared";
import InlineActionIconButton from "../../../../Button/InlineActionIconButton/InlineActionIconButton";
import { useTableStyles } from "../../../styles/styles";

interface ITableInlineActionsProps {
  scrollHorizontal?: boolean;
  inlineActions: any[];
  rowSwitch: any;
  row: TableRowData;
}

const TableInlineActions = ({
  scrollHorizontal,
  inlineActions,
  rowSwitch,
  row
}: ITableInlineActionsProps) => {
  const { user } = useAuth();

  const location = useLocation();

  const { tableInlineActionsBlock, firstTableInlineAction } =
    useTableStyles(rowSwitch);

  const companiesPage = location.pathname === ROUTES.Companies;

  return (
    <TableCell
      onClick={e => e.stopPropagation()}
      sx={[
        {
          position: "sticky",
          right: "0",
          padding: "0 !important",
          overflowX: "unset !important",
          boxShadow: `inset 0px -1px 0px ${colors.gray200}`,
          cursor: "auto",
          width: companiesPage ? "2%" : "unset"
        },
        tableColumnDropShadow(scrollHorizontal)
      ]}
    >
      <div css={css(tableInlineActionsBlock)} data-testid="inline-actions-cell">
        {rowSwitch?.renderConditions({ user }) && (
          <InlineToggleSwitch row={row} rowSwitch={rowSwitch} />
        )}

        {inlineActions.map((action: any, index: number) => {
          // if inlineActions renderConditions property is equal to true
          // then return inline action button

          return (
            <Fragment key={action.title}>
              {index === 0 && !rowSwitch && (
                <div css={css(firstTableInlineAction)} />
              )}
              {action.renderConditions({ data: row, user }) && (
                <InlineActionIconButton
                  title={action.title}
                  icon={action.icon}
                  rowData={row}
                  clickAction={action.clickAction}
                  hasLoader={action.hasLoader}
                  isEnabled={action?.isEnabled?.({ data: row, user })}
                />
              )}
            </Fragment>
          );
        })}
      </div>
    </TableCell>
  );
};

export default TableInlineActions;
